// Preserve API error details without retaining Axios requests, which may contain passwords.
export default class ApplicationError extends Error {
  constructor({ code, message, payload, retryAfter }) {
    super(message);
    this.name = 'ApplicationError';
    this.code = code;
    this.payload = payload;

    // Auth failures put wait time in payload; the global limiter returns it
    // at the response root. Forms use one property for both active contracts.
    this.retryAfter = payload?.retryAfter ?? retryAfter;
  }
}
